module.exports = __webpack_public_path__ + "assets/img/DP-1.f8d9cc41.jpg";